<ng-container *transloco="let t" class="container">
  <form [formGroup]="inputForm">
    <div class="modal-body">
      <div class="d-flex align-items-center">
        <img src="assets/img/svg/T.svg" alt="Tracy logo">
        <div class="d-flex align-items-start flex-grow-1">
          <div class="fw-semibold text-center title-wrapper line-height-1">
            {{ t('administrator.discounts.management.discountItem.add.title') }}
          </div>
        </div>
        <div class="pe-20 align-self-start">
          <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
          </button>
        </div>
      </div>
      <div class="body-wrapper">
        <app-input formControlName="numberOfRaces"
                   label="administrator.discounts.management.discountItem.add.numberOfRaces"/>
        <div class="pt-3">
          <app-input formControlName="amount"
                     label="administrator.discounts.management.discountItem.add.amount"/>
        </div>
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-center align-items-center pb-40-48">
    <div class="d-flex">
      <app-button (onClick)="onConfirmClick()" [label]="t('app.common.confirm')"
                  [btnClass]="'btn-primary-red text-uppercase'" [isDisabled]="!inputForm.valid ||
      !inputForm.touched"></app-button>
    </div>
  </div>
</ng-container>

